// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".p-status-dot{position:relative}.p-status-dot__dot{position:absolute;border-radius:9999px;top:.125rem;right:.1875rem;width:.625rem;height:.625rem}.p-status-dot--online{--tw-bg-opacity:1;background-color:rgba(var(--p-color-success), var(--tw-bg-opacity))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
